import { atom } from 'jotai';

/** Number of page views a logged-out user can make before seeing a login prompt. */
export const PAGE_VIEWS_BEFORE_LOGIN_PROMPT = 3;

/** Delay in ms after navigation before the login prompt can appear. */
export const LOGIN_PROMPT_DELAY_MS = 10_000;

/** Path prefixes that identify category / browse listing pages (plural routes). */
const CATEGORY_PATH_PREFIXES = [
    '/products',
    '/professionals',
    '/projects',
    '/rooms',
    '/articles',
];

/** Returns true when the pathname belongs to a category browse page. */
export const isCategoryPage = (pathname: string): boolean =>
    CATEGORY_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));

/** Tracks client-side page navigations for the current session. */
export const uiStateAtomPageViewCount = atom(0);
